import { UserSettingsContext } from "@hoylu/user-settings";
import { useCallback, useContext } from "react";
import { allLocalizations, Localized } from "../../strings";

export type LocalizingFunction = (
  address: string,
  ...parameters: any
) => string;

/** Get a localization function. To be used in React Functional Components */
export function useI18n(prefix: string = ""): LocalizingFunction {
  const { userSettings } = useContext(UserSettingsContext);
  // Resolve against the user's current language, falling back to English.
  // The locale is loaded on demand here so the function is reactive to
  // language changes, rather than relying on a one-off pushLocale side-effect
  // elsewhere (which left always-mounted components stuck on the default).
  const language = userSettings?.currentLanguage ?? "en";
  return useCallback(
    (addr: string, ...parameters: any) => {
      Localized.pushLocale(language, allLocalizations[language]);
      return Localized.string(prefix + addr, ...parameters);
    },
    [prefix, language],
  );
}
